import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  number: '24/7',
  label: 'Atención Especializada'
}, {
  number: '10+',
  label: 'Profesionales de Salud'
}, {
  number: '169',
  label: 'Calle Arenales, Gral. Ramírez'
}, {
  number: 'PRÓXIMA',
  label: 'Gran Apertura'
}];
export function Stats() {
  return <section className="bg-verde-oscuro text-white py-10 px-5 md:px-[5%]" data-id="element-81">
      <div className="flex justify-around flex-wrap gap-8 text-center max-w-7xl mx-auto" data-id="element-82">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="flex-1 min-w-[200px]" data-id="element-83">
            <h3 className="text-dorado text-[2.5rem] font-serif mb-2" data-id="element-84">
              {stat.number}
            </h3>
            <p className="uppercase text-[0.8rem] tracking-wider font-sans" data-id="element-85">
              {stat.label}
            </p>
          </motion.div>)}
      </div>
    </section>;
}